import { render, staticRenderFns } from "./BadgeProductIds.vue?vue&type=template&id=14e9db68&"
import script from "./BadgeProductIds.vue?vue&type=script&lang=ts&"
export * from "./BadgeProductIds.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports